// Cliente único de InsForge (SDK oficial). Firma verificada contra el skill
// insforge/database: createClient({ baseUrl, anonKey }). Devuelve { data, error }.
import { createClient } from '@insforge/sdk';

export const insforge = createClient({
  baseUrl: import.meta.env.VITE_INSFORGE_BASE_URL,
  anonKey: import.meta.env.VITE_INSFORGE_ANON_KEY,
  // El SDK deriva el host de functions como `<appkey>.functions.insforge.app`,
  // pero el deploy real vive en `<appkey>.function2.insforge.app`. Sin esto, el
  // preflight CORS del navegador da 404 y falla con "Failed to fetch".
  functionsUrl: import.meta.env.VITE_INSFORGE_FUNCTIONS_URL,
});
